import memoize from 'memoizee'
import { reduxForm, formValueSelector } from 'redux-form'
import { Text, Select } from '../../components/common'
import {
  SEARCH_FOR_TEACHER_FORM_NAME,
  SEARCH_FOR_TEACHER_FORM_FIELDS,
} from '../../constants/TeacherConstants'
import { searchForTeacher } from '../../actions/settingsTeacherAccess'
import { getAllCourses } from '../../selectors/course'
import { isEmpty } from '../../utils/common'

const selector = formValueSelector(SEARCH_FOR_TEACHER_FORM_NAME)

const mapStateToProps = state => {
  const { teacherSearch } = state
  const selectedCourseId = selector(state, SEARCH_FOR_TEACHER_FORM_FIELDS.courseField)

  return {
    initialValues: {
      [SEARCH_FOR_TEACHER_FORM_FIELDS.courseField]: '',
      [SEARCH_FOR_TEACHER_FORM_FIELDS.usernameField]: '',
    },
    courses: getAllCourses({ state, apOnly: false }),
    selectedCourseId,
    foundTeacher: teacherSearch,
  }
}

const mapCourses = memoize(courses => courses.map(c => ({ label: c.courseName, value: c.testCd })))

const FindTeacherForm = ({ courses, selectedCourseId, foundTeacher, handleSubmit, error }) => (
  <form onSubmit={handleSubmit}>
    <fieldset>
      <Select
        name={SEARCH_FOR_TEACHER_FORM_FIELDS.courseField}
        label="Courses"
        isRequired={true}
        options={mapCourses(courses)}
        showEmptyOption={true}
      />

      <Text
        name={SEARCH_FOR_TEACHER_FORM_FIELDS.usernameField}
        isSearchBox={true}
        isRequired={true}
        disabled={
          isEmpty(selectedCourseId) || (foundTeacher.fetched && !isEmpty(foundTeacher.personId))
        }
        label="Teacher's College Board Username"
        placeholder="Enter username"
        additionalText="Teachers must create a College Board account before you can grant them access."
        maxlength="20"
      />

      {error && (
        <p
          tabIndex="-1"
          id={`errMessage-${SEARCH_FOR_TEACHER_FORM_NAME}`}
          className="cb-error-msg"
          role="alert"
        >
          {error}
        </p>
      )}
    </fieldset>
  </form>
)

export default connect(mapStateToProps, { searchForTeacher })(
  reduxForm({
    form: SEARCH_FOR_TEACHER_FORM_NAME,
    returnRejectedSubmitPromise: true,
    onSubmit: (values, dispatch, { searchForTeacher }) =>
      searchForTeacher({ username: values[SEARCH_FOR_TEACHER_FORM_FIELDS.usernameField] }),
  })(FindTeacherForm)
)
